// Onde mora o dado e o arquivo de uma conta, do lado do app do eia.
//
// Até 19/09/2026 o mesmo dado era procurado em quatro caminhos diferentes, e cada parte do
// sistema escolhia um: `cliente/{slug}` (legado), `accounts/acc_{slug}/{tipo}` (espelho da
// migração de 18/09), `accounts/acc_{slug}/modules/grc/{fluxo}` e um resto de migração antiga.
// A decisão do dono, em 19/09: **o canônico é `accounts/{conta}/modules/grc/{fluxo}`**, e o
// mesmo prefixo `accounts/{conta}` vale para os arquivos no Storage.
//
// Este módulo é o espelho de modules/eia/functions/caminhosGrc.js. Os dois precisam responder
// igual: a entrevista que o app escreve é a que o gatilho lê.

const normalizarSlug = (valor) => String(valor || '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

// Aceita tanto "materdei" quanto "acc_materdei": o chamador nem sempre sabe qual tem em mãos.
export const contaDaEmpresa = (empresa) => {
  const bruto = String(empresa || '').trim();
  if (!bruto) return '';
  const slug = normalizarSlug(bruto.startsWith('acc_') ? bruto.slice(4) : bruto);
  return slug ? `acc_${slug}` : '';
};

export const baseDaConta = (empresa) => {
  const conta = contaDaEmpresa(empresa);
  return conta ? `accounts/${conta}` : '';
};

const normalizarTipo = (valor) => {
  const bruto = String(valor || '').trim().toLowerCase();
  return bruto === 'recrutamento' ? 'recrutamento-e-selecao' : bruto;
};

const FLUXO_POR_TIPO = {
  'pesquisa-de-compliance': 'denuncias',
  'pesquisas-de-compliance': 'denuncias',
  denuncias: 'denuncias',
  'recrutamento-e-selecao': 'recrutamento_e_selecao',
  recrutamento_e_selecao: 'recrutamento_e_selecao',
  'pesquisa-de-clima': 'pesquisa-de-clima',
};

export const fluxoDoTipo = (tipo) => FLUXO_POR_TIPO[normalizarTipo(tipo)] || '';

// accounts/{conta}/modules/grc/{fluxo} — a coleção de casos de um fluxo.
export const colecaoDoFluxo = ({ empresa, tipo }) => {
  const base = baseDaConta(empresa);
  const fluxo = fluxoDoTipo(tipo);
  return base && fluxo ? `${base}/modules/grc/${fluxo}` : '';
};

export const caminhoDoCaso = ({ empresa, tipo, caso }) => {
  const colecao = colecaoDoFluxo({ empresa, tipo });
  const id = String(caso || '').trim();
  return colecao && id ? `${colecao}/${id}` : '';
};

export const caminhoDaEntrevista = ({ empresa, tipo, caso, entrevista }) => {
  const doc = caminhoDoCaso({ empresa, tipo, caso });
  const id = String(entrevista || '').trim();
  return doc && id ? `${doc}/entrevistas/${id}` : '';
};

// O `_meta` do fluxo guarda roteiros e formulário de feedback, como em cliente/{slug}/{tipo}/_meta.
export const caminhoDoMeta = ({ empresa, tipo }) => {
  const colecao = colecaoDoFluxo({ empresa, tipo });
  return colecao ? `${colecao}/_meta` : '';
};

export const caminhoDoLogo = (empresa) => {
  const base = baseDaConta(empresa);
  return base ? `${base}/logo.png` : '';
};
